<template>
  <div v-if="hub">
    <h3> {{hub.manufacturer.name}} - {{hub.model}}</h3>
    <ul>
      <li v-if="hub.axleWidth > 0">Axle width: {{hub.axleWidth}} mm</li>
      <li v-if="hub.weight > 0">Weight: {{hub.weight}} g</li>
    </ul>
    <div class="front-hub" v-if="!hub.rear">
      <img src="/static/img/spoke/frontwheel.png">
      <div class="left-dia">{{hub.leftFlangeDiameter}}</div>
      <div class="right-dia">{{hub.rightFlangeDiameter}}</div>
      <div class="left2-center">{{hub.leftFlangeToCenter}}</div>
      <div class="right2-center">{{hub.rightFlangeToCenter}}</div>
    </div>
    <div class="rear-hub" v-else>
      <img src="/static/img/spoke/rearwheel.png">
      <div class="left-dia">{{hub.leftFlangeDiameter}}</div>
      <div class="right-dia">{{hub.rightFlangeDiameter}}</div>
      <div class="left2-center">{{hub.leftFlangeToCenter}}</div>
      <div class="right2-center">{{hub.rightFlangeToCenter}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'hub-display',
    props: ['hub'],
  }
</script>

<style scoped>
  img {
    width: 100%;
  }

  ul {
    list-style: none;
    text-align: left;
  }

  .rear-hub,
  .front-hub {
    position: relative;
  }

  .left-dia {
    position: absolute;
    top: 35%;
    left: 0;
  }

  .right-dia {
    position: absolute;
    top: 35%;
    right: 0;
  }

  .left2-center {
    position: absolute;
    left: 44%;
    bottom: 0;
  }

  .right2-center {
    position: absolute;
    left: 62%;
    bottom: 0;
  }

  .rear-hub .left2-center {
    left: 40%;
  }

  .rear-hub .right2-center {
    left: 55%;
  }
</style>



// WEBPACK FOOTER //
// src/components/hub-display.vue